import {
  FETCH_YARD_MAP,
  FETCH_YARD_MAP_SUCCESS,
  FETCH_YARD_MAP_FAILURE,
  CREATE_YARD_MAP,
  CREATE_YARD_MAP_SUCCESS,
  CREATE_YARD_MAP_FAILURE,
  DELETE_YARD_MAP,
  DELETE_YARD_MAP_SUCCESS,
  DELETE_YARD_MAP_FAILURE,
  RESET_YARD_MAP_STATE,
  CLEAR_ERROR_DELETING_YARD_MAP,
} from "./yardMapActionTypes";
import {
  EDIT_YARD_MAP,
  EDIT_YARD_MAP_SUCCESS,
  EDIT_YARD_MAP_FAILURE,
  CLEAR_ERROR_EDITING_YARD_MAP,
} from "./editYardMapActionTypes";
import { EDIT_YARD_MAP_TYPES } from "app-constants";

const { SAVE_LOCATION_DETAILS, REQUEST_REMAPPING, DELETE_LOCATION_MAPPING, SAVE_OFFSET } =
  EDIT_YARD_MAP_TYPES;

const INITIAL_YARD_MAP_DATA = {
  fetchingYardMap: false,
  creatingYardMap: false,
  deletingYardMap: false,
  editingYardMap: {
    [SAVE_LOCATION_DETAILS]: false,
    [REQUEST_REMAPPING]: false,
    [DELETE_LOCATION_MAPPING]: false,
    [SAVE_OFFSET]: false,
  },
  yardMap: {},
  errorFetchingYardMap: null,
  errorCreatingYardMap: null,
  errorDeletingYardMap: null,
  errorEditingYardMap: null,
};

const clearAllErrors = (state) => ({
  ...state,
  errorFetchingYardMap: null,
  errorCreatingYardMap: null,
  errorEditingYardMap: null,
  errorDeletingYardMap: null,
});

export const yardMapReducer = (state = INITIAL_YARD_MAP_DATA, action) => {
  switch (action.type) {
    case FETCH_YARD_MAP:
      return {
        ...state,
        fetchingYardMap: true,
        errorFetchingYardMap: null,
      };

    case FETCH_YARD_MAP_SUCCESS: {
      const { yardMap } = action.payload;
      return clearAllErrors({
        ...state,
        fetchingYardMap: false,
        yardMap,
      });
    }

    case FETCH_YARD_MAP_FAILURE:
      return {
        ...state,
        fetchingYardMap: false,
        errorFetchingYardMap: action.payload,
      };
    case CREATE_YARD_MAP:
      return {
        ...state,
        creatingYardMap: true,
        errorCreatingYardMap: null,
      };
    case CREATE_YARD_MAP_SUCCESS:
      return clearAllErrors({
        ...state,
        creatingYardMap: false,
        yardMap: action.payload,
        errorCreatingYardMap: null,
      });
    case CREATE_YARD_MAP_FAILURE:
      return {
        ...state,
        creatingYardMap: false,
        errorCreatingYardMap: action.payload,
      };

    case DELETE_YARD_MAP:
      return {
        ...state,
        deletingYardMap: true,
        errorDeletingYardMap: null,
      };

    case DELETE_YARD_MAP_SUCCESS:
      return clearAllErrors({
        ...state,
        deletingYardMap: false,
        yardMap: {},
      });

    case DELETE_YARD_MAP_FAILURE:
      return {
        ...state,
        deletingYardMap: false,
        errorDeletingYardMap: action.payload,
      };

    case CLEAR_ERROR_DELETING_YARD_MAP:
      return {
        ...state,
        errorDeletingYardMap: null,
      };

    case EDIT_YARD_MAP:
      return {
        ...state,
        editingYardMap: {
          ...state.editingYardMap,
          [action.payload]: true,
        },
        errorEditingYardMap: null,
      };

    case EDIT_YARD_MAP_SUCCESS: {
      const { editType, yardMap } = action.payload;
      return clearAllErrors({
        ...state,
        editingYardMap: {
          ...state.editingYardMap,
          [editType]: false,
        },
        yardMap: yardMap,
      });
    }

    case EDIT_YARD_MAP_FAILURE: {
      const { editType, error } = action.payload;
      return {
        ...state,
        editingYardMap: {
          ...state.editingYardMap,
          [editType]: false,
        },
        errorEditingYardMap: error,
      };
    }

    case CLEAR_ERROR_EDITING_YARD_MAP:
      return {
        ...state,
        errorEditingYardMap: null,
      };

    case RESET_YARD_MAP_STATE:
      return {
        ...INITIAL_YARD_MAP_DATA,
      };

    default:
      return state;
  }
};
